import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthContext } from "./components/Auth/AuthContext";

const AppRoutes = lazy(() => import("./Routes"));
const PublicRoutes = lazy(() => import("./PublicRoutes"));

function App() {
  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div className="global-loader"><div className="spinner"></div></div>}>
          <Routes>
            <Route
              path="*"
              element={
                <AuthContext.Consumer>
                  {({ token }) => {
                    return token ? <AppRoutes /> : <PublicRoutes />;
                  }}
                </AuthContext.Consumer>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
export { App };
